import styled from 'styled-components'

const StyledLessonContent = styled.div`
  .lesson-details {
    display: grid;
    grid-gap: 1rem;
    padding: 25px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};

    h1 {
      font-weight: 500;
      line-height: unset;
      font-size: 22px;
      font-family: ${({ theme }) => theme.fonts.lexend};
      letter-spacing: 0.01rem;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .lesson-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn {
        height: 46px;
        font-family: ${({ theme }) => theme.fonts.lexend};
        font-weight: 400;
        letter-spacing: 0.1rem;

        svg {
          margin-left: 2rem;
        }
      }
    }
  }

  .lesson-content {
    display: grid;
    grid-gap: 25px;
    align-items: start;
    grid-template-columns: minmax(0, 1fr);
    font-family: ${({ theme }) => theme.fonts.nunito};
    margin-top: 25px;

    .lesson-description {
      .sub-title {
        font-weight: 700;
      }

      .description {
        max-width: 650px;
        margin-top: 20px;
        width: 100%;
        font-weight: 500;
        line-height: 27px;
        color: ${({ theme }) => theme.colors.gray[700]};

        div {
          white-space: pre-wrap;

          p:not(:first-child) {
            margin-top: 1rem;
          }
        }
      }
    }

    .btn {
      height: 46px;
      width: 100%;
      justify-content: space-between;
      font-family: ${({ theme }) => theme.fonts.lexend};
      font-weight: 400;
      padding-left: 1rem;
      font-size: 1rem;
    }

    .lesson-downloads {
      grid-gap: 25px;
      display: grid;

      .lesson-additional-content {
        background: ${({ theme }) => theme.colors.gray[50]};
        color: ${({ theme }) => theme.colors.gray[700]};
        border-radius: 10px;
        grid-gap: 10px;
        display: grid;

        b {
          padding: 1rem 1rem 0 1rem;
        }

        ul {
          list-style-type: none;
          padding: 0 10px 10px 10px;
          color: ${({ theme }) => theme.colors.gray[700]};
          grid-gap: 0px;
          display: grid;

          li {
            a {
              padding: 6px;
              border-radius: 3px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-family: ${({ theme }) => theme.fonts.nunito};
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              transition: background 0.2s;

              svg {
                height: 20px;
                flex-shrink: 0;
                margin-left: 1rem;
              }

              &:hover {
                background: ${({ theme }) => theme.colors.gray[100]};
              }

              &:active {
                background: ${({ theme }) => theme.colors.gray[200]};
              }
            }
          }
        }
      }
    }
  }

  .lesson-video {
    margin-top: 1rem;
    position: relative;

    .lesson-up-next-container {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: #000000bd;
      border-radius: 3px;

      .lesson-up-next {
        position: absolute;
        left: 50%;
        top: 50%;
        max-width: 350px;
        width: 100%;
        transform: translate(-50%, -50%);
        color: ${({ theme }) => theme.colors.background};
        display: grid;
        grid-gap: 1rem;
        line-height: 22px;
        font-size: 16px;
        letter-spacing: 0.02rem;

        .thumbnail {
          position: relative;
          padding-top: 56.25%;

          img {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            border-radius: 3px;
          }
        }

        .actions {
          display: grid;
          grid-gap: 1rem;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

          .btn {
            width: 100%;
          }
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .lesson-details {
      display: flex;
      align-items: end;
      justify-content: space-between;

      h1 {
        font-size: 32px;
        line-height: inherit;
      }

      .lesson-actions {
        flex-flow: row-reverse;
      }
    }

    .lesson-content {
      grid-gap: 70px;
      grid-template-columns: minmax(0, 1fr) 215px;
    }
  }
`

export default StyledLessonContent
